"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var native_1 = require("styled-components/native");
var Themes_1 = require("./Themes");
var Context = react_1.default.createContext(Themes_1.defaultTheme);
var ContextThemeProvider = Context.Provider;
exports.ATLThemeProvider = function (_a) {
    var projectTheme = _a.theme, children = _a.children;
    var fullTheme = __assign(__assign({}, Themes_1.defaultTheme), projectTheme);
    return (react_1.default.createElement(ContextThemeProvider, { value: fullTheme },
        react_1.default.createElement(native_1.ThemeProvider, { theme: fullTheme }, children)));
};
exports.useTheme = function () {
    return react_1.useContext(Context);
};
